import axios from 'axios';
import api from './api';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v1';

// Get auth token from localStorage
const getAuthToken = () => {
  const token = localStorage.getItem('token');
  return token;
};

// Create axios instance with auth header
const createAuthHeaders = () => {
  const token = getAuthToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
};

// Get all meetings with optional filters
export const getMeetings = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.search) params.append('search', filters.search);
  if (filters.project_id) params.append('project_id', filters.project_id);
  if (filters.meeting_type) params.append('meeting_type', filters.meeting_type);
  if (filters.status) params.append('status', filters.status);
  if (filters.start_date) params.append('start_date', filters.start_date);
  if (filters.end_date) params.append('end_date', filters.end_date);
  if (filters.page) params.append('page', filters.page);
  if (filters.limit) params.append('limit', filters.limit);

  const queryString = params.toString();
  const url = `/meetings${queryString ? `?${queryString}` : ''}`;
  
  const response = await api.get(url, createAuthHeaders());
  return response.data;
};

// Get meeting by ID
export const getMeeting = async (id) => {
  const response = await api.get(`/meetings/${id}`, createAuthHeaders());
  return response.data;
}; 

// Create new meeting
export const createMeeting = async (meetingData) => {
  const response = await api.post(`/meetings`, meetingData, createAuthHeaders());
  return response.data;
};

// Update meeting
export const updateMeeting = async (id, meetingData) => {
  const response = await api.put(`/meetings/${id}`, meetingData, createAuthHeaders());
  return response.data;
};

// Delete meeting
export const deleteMeeting = async (id) => {
  const response = await api.delete(`/meetings/${id}`, createAuthHeaders());
  return response.data;
};

// Add participant to meeting
export const addParticipant = async (meetingId, participantData) => {
  const response = await api.post(
    `/meetings/${meetingId}/participants`,
    participantData,
    createAuthHeaders()
  );
  return response.data;
};

// Remove participant from meeting
export const removeParticipant = async (meetingId, participantId) => {
  const response = await api.delete(
    `/meetings/${meetingId}/participants/${participantId}`,
    createAuthHeaders()
  );
  return response.data;
};

// Update participant response
export const updateParticipantResponse = async (meetingId, participantId, responseData) => {
  const response = await api.put(
    `/meetings/${meetingId}/participants/${participantId}`,
    responseData,
    createAuthHeaders()
  );
  return response.data;
};

// Get meeting statistics
export const getMeetingStats = async () => {
  const response = await api.get(`/meetings/stats`, createAuthHeaders());
  return response.data;
};

const meetingService = {
  getMeetings,
  getMeeting,
  createMeeting,
  updateMeeting,
  deleteMeeting,
  addParticipant,
  removeParticipant,
  updateParticipantResponse,
  getMeetingStats,
};

export default meetingService;


